import areas from '@config/areas.json';

type AuthRouteType = 'home' | 'login' | 'logout' | '401';

type ResolveContext = {
  locale: string;
  path: string;
  query?: Record<string, string | undefined>;
  area?: string;
};

type ResolvedAuthRoute = {
  name: string;
  params: { locale: string };
  query: Record<string, string | undefined>;
};

const areaConfig = areas as Record<string, Record<string, string>>;

const resolveAuthRoute = (type: AuthRouteType, context: ResolveContext): ResolvedAuthRoute => {
  const area = context.area && areaConfig[context.area] ? context.area : 'admin';
  const name = areaConfig[area]?.[type] ?? areaConfig.admin[type];

  return {
    name,
    params: { locale: context.locale },
    query: {
      requiresAuth: 'true',
      redir: context.path,
      noRedirect: 'true',
      ...(context.query?.error && { error: context.query.error }),
      ...(context.query?.error_description && {
        error_description: context.query.error_description,
      }),
    },
  };
};

export { resolveAuthRoute };
export type { AuthRouteType, ResolveContext, ResolvedAuthRoute };
